import { isMultiValueSubfield } from './multiValueSubfield';
export var acceptsSuggestVocabulary = function (sf) {
    return (!sf.inputType || sf.inputType === 'text')
        && !sf.actionButton
        && !sf.readOnly
        && !sf.derivedFrom
        && !sf.hasComponents
        && !isMultiValueSubfield(sf);
};
